import template from './sidebar.html';

export const sidebarComponent = {
  name: 'sidebarComponent',
  restrict: 'E',
  template,
  transclude: true,
  controllerAs: 'vm',
  controller: function ($element) {
    'ngInject';
    this.$onInit = function () {
      $element.addClass('sidebar sidebar-sticky');
    };
  },
  bindings: {
    sections: '<',
  },
};
